import { render, staticRenderFns } from "./mbgl.vue?vue&type=template&id=2e622bab&scoped=true&"
import script from "./mbgl.vue?vue&type=script&lang=js&"
export * from "./mbgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e622bab",
  null
  
)

export default component.exports